import React from 'react';
import { getUTCHtmlId } from 'common/util/time';
import useMapsStore from '../store/useMapsStore';
function MapAccordion({ children }) {
    const accordionId = 'accordion-' + getUTCHtmlId();
    const buttonId = 'accordion-buttton-' + getUTCHtmlId();
    const { lotListExpanded, setLotListExpanded } = useMapsStore();
    return (React.createElement("div", { className: "viewport-map__accordion" },
        React.createElement("button", { id: buttonId, "aria-expanded": lotListExpanded, "aria-controls": accordionId, className: "viewport-map__accordion-button", onClick: () => setLotListExpanded(!lotListExpanded) },
            React.createElement("span", { className: "sr-only" }, "Toggle Lot Listing Accordion"),
            React.createElement("i", { className: 'fa-solid' + (lotListExpanded ? ' fa-angles-right' : ' fa-angles-left') })),
        React.createElement("aside", { id: accordionId, "aria-labelledby": buttonId, className: 'viewport-map__accordion-content' +
                (lotListExpanded ? ' viewport-map__accordion-content--expanded' : '') }, children)));
}
export default MapAccordion;
export const MemoizedMapAccordion = React.memo(MapAccordion);
